import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import ROUTES from '../../../routes/Routes.js';

export default function PricingTable({ price, currentPage, itemsPerPage, handleSort, sortField, sortOrder }) {
    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th onClick={() => handleSort('name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Nombre{' '}
                            {sortField === 'name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th scope="col">Value</th>
                        <th scope="col">Última modificación</th>
                        <th scope="col">Comentarios</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {price?.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center">
                                No hay registros disponibles
                            </td>
                        </tr>
                    ) : (
                        price.map((pricing, index) => {
                            const rowNumber = (currentPage - 1) * itemsPerPage + index + 1;
                            return (
                                <tr key={pricing.id}>
                                    <td>{rowNumber}</td>
                                    <td>{pricing.name}</td>
                                    <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(pricing.value)}</td>
                                    <td>{format(new Date(pricing.updatedAt), 'dd-MM-yyyy')}</td>
                                    <td>{pricing.description}</td>
                                    <td>    
                                        <Link to={`${ROUTES.EDIT_PRICING_HOURS}/${pricing.id}`} className="btn btn-primary me-md-2"><i className="bi bi-pencil-square"></i></Link>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </>
    );
}